import EfVideo from '@elem/ui/ef-video';
import css from './index.module.scss';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import getLocal from 'eco-design-reliance/getLocal';
const IconRePlay = (props: any) => {
    return (
        <div {...props}>
            <img src="https://websiteoss.ecoflow.com/upload/image/1773215072797/Frame%20128720591.png" alt="replay" />
        </div>
    );
};
interface ItemProps {
    sources?: [string, string];
    posters?: [string, string];
    img?: [string, string];
    tab: string;
    tab2: string;
    desc: any;
    icon: string;
    iphone?: string;
    rightIcon?: [string, string];
}
export default function B() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const { locale = '' } = getLocal();
    const IS_AU = locale === 'au';
    const [enter, setEnter] = useState(false);
    const [active, setActive] = useState(0);
    const [iphoneVisible, setIphoneVisible] = useState(false);
    const [rightIconVisible, setRightIconVisible] = useState(false);
    const [videoEndedMap, setVideoEndedMap] = useState(false);
    const items: ItemProps[] = [
        {
            sources: [
                'https://websiteoss.ecoflow.com/upload/video/1773217825173/DPU%E5%86%8D%E8%90%A5%E9%94%80%E7%B4%A0%E6%9D%90_1.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1773217825173/DPU%E5%86%8D%E8%90%A5%E9%94%80%E7%B4%A0%E6%9D%90_1.mp4',
            ],
            posters: [
                'https://websiteoss.ecoflow.com/upload/image/1773198815350/4-pc-1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1773198814249/4-m-1.jpg',
            ],
            tab: t('OASIS1_item1_tab'),
            tab2: t('OASIS1_item1_tab2'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1772621006531/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%204%20(1).png',
            rightIcon: [
                'https://websiteoss.ecoflow.com/upload/image/1773198816889/4-pc-icon.png',
                'https://websiteoss.ecoflow.com/upload/image/1773198816159/4-m-icon.png',
            ],
            desc: 'OASIS1_item1_desc',
        },
        {
            sources: IS_AU
                ? undefined
                : [
                      'https://websiteoss.ecoflow.com/upload/video/1773217972224/%E5%B8%82%E7%94%B5%E5%8A%A8%E7%94%BB%20(1).mp4',
                      'https://websiteoss.ecoflow.com/upload/video/1773217824953/%E5%B8%82%E7%94%B5%E5%8A%A8%E7%94%BB.mp4',
                  ],
            posters: IS_AU
                ? undefined
                : [
                      'https://websiteoss.ecoflow.com/upload/image/1773198815048/4-pc-2.jpg',
                      'https://websiteoss.ecoflow.com/upload/image/1773198974301/4-m-2.jpg',
                  ],
            img: IS_AU
                ? [
                      'https://websiteoss.ecoflow.com/figma-uploads/1784715923626-pz8v9s-compressed-Frame%202094654978.jpg',
                      'https://websiteoss.ecoflow.com/figma-uploads/1784715953965-h7xkt4-compressed-Frame%202094655024.jpg',
                  ]
                : undefined,
            tab: t('OASIS1_item2_tab'),
            tab2: t('OASIS1_item2_tab2'),
            icon: IS_AU
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1784715792504-n819vs-compressed-%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%205.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1772621006722/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%205.png',
            desc: 'OASIS1_item2_desc',
        },
        {
            img: IS_AU
                ? [
                      'https://websiteoss.ecoflow.com/figma-uploads/1784715936802-n8xk4n-compressed-image.jpg',
                      'https://websiteoss.ecoflow.com/figma-uploads/1784715960729-jvth0b-compressed-Frame%202094655025.jpg',
                  ]
                : [
                      'https://websiteoss.ecoflow.com/upload/image/1773198814796/4-pc-3.jpg',
                      'https://websiteoss.ecoflow.com/upload/image/1773198813986/4-m-3.jpg',
                  ],
            tab: t('OASIS1_item3_tab'),
            tab2: t('OASIS1_item3_tab2'),
            icon: IS_AU
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1784715871925-enpfct-compressed-%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%205.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1772621047622/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%206.png',
            desc: 'OASIS1_item3_desc',
            iphone: 'https://websiteoss.ecoflow.com/upload/image/1773198814408/4-iphone-pc.png',
        },
    ];
    if (IS_AU) {
        items.shift();
    }

    const handleChangeTab = (e: MouseEvent, k: number) => {
        const target = e.target as HTMLElement;
        const line = document.querySelector('.OASIS-1 .line') as HTMLElement;
        // setVideoEndedMap(true)
        // 对准下面的条
        const { left, width } = target.getBoundingClientRect();
        const { left: parentLeft = left } = target.parentElement?.getBoundingClientRect() ?? {};
        const scrollX = (target.parentElement as HTMLElement).scrollLeft ?? 0;
        line.style.transform = `translateX(${left - parentLeft + scrollX}px)`;
        line.style.width = `${width}px`;

        // h5 情况下切换 tab 需要显示出来
        if (window.innerWidth <= 1024) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        setActive(k);
        if (k === 2) {
            setIphoneVisible(false);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => setIphoneVisible(true));
            });
        } else {
            setIphoneVisible(false);
        }
        if (k === 0) {
            setRightIconVisible(false);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => setRightIconVisible(true));
            });
        } else {
            setRightIconVisible(false);
        }
        // const targetVideos = document.querySelectorAll(`.OASIS-1 .video${k + 1} video`) as NodeListOf<HTMLVideoElement>;
        // targetVideos.forEach(v => {
        //     v.currentTime = 0;
        //     v.play().catch(() => {});
        // });
        // setVideoEndedMap(false)
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.dpu-detail-E',
                triggerHook: 1,
                offset: '100%',
                onEnter: () => {
                    setEnter(true);
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => setRightIconVisible(true));
                    });
                },
            });

            return () => {
                scene.destroy();
            };
        }
    }, []);

    return (
        <>
            <section id="OASIS-1" className={`OASIS-1 ${css['OASIS-1']}`}>
                <EfSpec />
                {(t('OASIS1_title') || t('OASIS1_desc')) && (
                    <div className="info">
                        {t('OASIS1_title') && <p className="title">{t('OASIS1_title')}</p>}
                        {t('OASIS1_desc') && <p className="text">{t('OASIS1_desc')}</p>}
                    </div>
                )}
                <ul className="videos">
                    {items?.map((item: ItemProps, k: number) => (
                        <li key={k} className={`video video${k + 1} ${k === active ? 'active' : ''}`}>
                            {item.img ? (
                                <>
                                    <EcoImg className="tab-img" pc={item.img[0]} h5={item.img[1]} />
                                    {item.iphone && <EcoImg className={`iphone-img ${iphoneVisible ? 'iphone-visible' : ''}`} pc={item.iphone} />}
                                </>
                            ) : (
                                enter && (
                                    <>
                                        <EfVideo
                                            className="video1"
                                            pc={item.sources![0]}
                                            h5={item.sources![0]}
                                            poster={item.posters![0]}
                                            posterH5={item.posters![1]}
                                            // loop={true}
                                            autoPlay={true}
                                            Icon={IconRePlay}
                                            // startPlay={videoEndedMap}
                                        />
                                        {item.rightIcon && (
                                            <EcoImg
                                                className={`rightIcon-img ${rightIconVisible ? 'rightIcon-visible' : ''}`}
                                                pc={item.rightIcon[0]}
                                                pad={item.rightIcon[1]}
                                            />
                                        )}
                                    </>
                                )
                            )}
                        </li>
                    ))}
                </ul>
                <ul className="tabs">
                    {items?.map((item: ItemProps, k: number) => (
                        <li className={`tab ${active === k ? 'active' : ''}`} onClick={(e: MouseEvent) => handleChangeTab(e, k)}>
                            {/* {item.icon} */}
                            <EcoImg className="icon" pc={item.icon}></EcoImg>
                            <span className="tab-text">
                                <span>{item.tab}</span>
                                <p className="tab-text2">{item.tab2}</p>
                            </span>
                        </li>
                    ))}
                    <p className="line"></p>
                </ul>
                <p className="desc">
                    {t.rich(items[active].desc, {
                        w: (child: string) => <span className="white-text">{child}</span>,
                    })}
                </p>
                {!['au'].includes(locale) && <EfSpec />}
            </section>
        </>
    );
}
